import { render, staticRenderFns } from "./edition-public-card.vue?vue&type=template&id=394507ea&scoped=true&"
import script from "./edition-public-card.vue?vue&type=script&lang=ts&"
export * from "./edition-public-card.vue?vue&type=script&lang=ts&"
import style0 from "./edition-public-card.vue?vue&type=style&index=0&id=394507ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394507ea",
  null
  
)

export default component.exports